import { render } from "./Loader.vue?vue&type=template&id=d1763dd4"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1763dd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1763dd4', __exports__)) {
    api.reload('d1763dd4', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=d1763dd4", () => {
    api.rerender('d1763dd4', render)
  })

}


export default __exports__